export default "__VITE_ASSET__DG$fvOZu__"